package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_register_configuration.tabs.operation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.style.toModifier
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.CountriesEnum
import org.hs_soft.runmynesto.domain.model.home.options.LanguageEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.kotlin_api.CashRegisterConfig
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.CustomTextArea
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun OperationTabCashRegisterConfig(
    windowSizeMode: WindowSizeModeEnum,
    updateCashRegisterConfig: (List<Pair<String, dynamic>>) -> Unit,
    cashRegisterConfig: CashRegisterConfig?
) {
    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(Dimen.extraLargePadding)
            .borderRadius(Dimen.semiLargeRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
    ) {
        if (windowSizeMode == WindowSizeModeEnum.Desktop){
            Row() {
                content(
                    windowSizeMode =windowSizeMode,
                    cashRegisterConfig = cashRegisterConfig,
                    updateCashRegisterConfig = updateCashRegisterConfig
                )
            }
        } else {
            Column(
                modifier = VerticalScrollBehavior
                    .toModifier()
                    .fillMaxHeight()
            ) {
                content(
                    windowSizeMode = windowSizeMode,
                    cashRegisterConfig = cashRegisterConfig,
                    updateCashRegisterConfig = updateCashRegisterConfig
                )
            }
        }
    }
}


@Composable
private fun content(
    windowSizeMode: WindowSizeModeEnum,
    cashRegisterConfig: CashRegisterConfig?,
    updateCashRegisterConfig: (List<Pair<String, dynamic>>) -> Unit
) {
    val country = remember { mutableStateOf(cashRegisterConfig?.country ?: 0) }
    val language = remember { mutableStateOf(LanguageEnum.fromDisplayName(cashRegisterConfig?.getLanguageDisplayName().orEmpty())) }

    LaunchedEffect(cashRegisterConfig) {
        country.value = cashRegisterConfig?.country ?: 0
        language.value = LanguageEnum.fromDisplayName(cashRegisterConfig?.getLanguageDisplayName().orEmpty())
    }

    Column(
        modifier = Modifier
            .margin(right = Dimen.normalPadding)
    ) {
        CustomEditText(
            modifier = Modifier,
            label = Strings.current().companyName,
            value = cashRegisterConfig?.companyName.orEmpty(),
            hint = "",
            isOutlinedEditText = true,
            onFocusIn = {},
            onFocusOut = {
                updateCashRegisterConfig(
                    buildList { add(ApiUtils.Field.clientConfigCompanyName to it) }
                )
            },
            onInputChange = { it, validation ->

            },
        )

        CustomEditText(
            modifier = Modifier
                .margin(top = Dimen.smallPadding),
            label = Strings.current().street,
            value = cashRegisterConfig?.companyStreet.orEmpty(),
            hint = "",
            isOutlinedEditText = true,
            onFocusIn = {

            },
            onFocusOut = {
                updateCashRegisterConfig(
                    buildList { add(ApiUtils.Field.clientConfigCompanyStreet to it) }
                )
            },
            onInputChange = {it, validation ->

            },
        )

        Row(
            modifier = Modifier
                .margin(top = Dimen.smallPadding)
        ) {
            CustomEditText(
                modifier = Modifier,
                width = Dimen.smallEditTextWidth,
                label = Strings.current().zip,
                value = cashRegisterConfig?.companyZIP.orEmpty(),
                hint = "",
                isOutlinedEditText = true,
                onFocusIn = {

                },
                onFocusOut = {
                    updateCashRegisterConfig(
                        buildList { add(ApiUtils.Field.clientConfigCompanyZIP to it) }
                    )
                },
                onInputChange = {it, validation ->

                },
            )

            Box(modifier = Modifier.padding(Dimen.smallPadding))

            CustomEditText(
                modifier = Modifier,
                width = (Dimen.mediumEditTextWidth.value.toInt()
                        - Dimen.normalPadding.value.toInt()
                        - Dimen.smallEditTextWidth.value.toInt()).px,
                label = Strings.current().city,
                value = cashRegisterConfig?.companyCity.orEmpty(),
                hint = "",
                isOutlinedEditText = true,
                onFocusIn = {

                },
                onFocusOut = {
                    updateCashRegisterConfig(
                        buildList { add(ApiUtils.Field.clientConfigCompanyCity to it) }
                    )
                },
                onInputChange = {it, validation ->

                },
            )
        }

        CustomEditText(
            modifier = Modifier
                .margin(top = Dimen.smallPadding),
            label = Strings.current().vatNumber,
            value = cashRegisterConfig?.companyVATNo.orEmpty(),
            hint = "",
            isOutlinedEditText = true,

            onFocusIn = {

            },
            onFocusOut = {
                updateCashRegisterConfig(
                    buildList { add(ApiUtils.Field.clientConfigCompanyVatNo to it) }
                )
            },
            onInputChange = {it, validation ->

            },
        )

        CustomEditText(
            modifier = Modifier
                .margin(top = Dimen.smallPadding),
            label = Strings.current().telephoneNumber,
            value = cashRegisterConfig?.companyTelephone.orEmpty(),
            hint = "",
            isOutlinedEditText = true,
            onFocusIn = {

            },
            onFocusOut = {
                updateCashRegisterConfig(
                    buildList { add(ApiUtils.Field.clientConfigCompanyTelephone to it) }
                )
            },
            onInputChange = {it, validation ->

            },
        )

        DropDownItem(
            modifier = Modifier
                .margin(top = Dimen.smallPadding),
            options = CountriesEnum.entries,
            label = Strings.current().country,
            selectedItem = CountriesEnum.entries.find {
                it.id == country.value.toString()
            },
            displayText = {
                it.toString()
            },
            onOptionClick = {
                country.value = (it as CountriesEnum).id.toInt()

                updateCashRegisterConfig(
                    buildList { add(ApiUtils.Field.clientConfigCountry to country.value) }
                )
            },
        )

        DropDownItem(
            modifier = Modifier
                .margin(top = Dimen.smallPadding),
            options = LanguageEnum.entries,
            label = Strings.current().language,
            selectedItem = LanguageEnum.fromDisplayName(language.value?.displayName.orEmpty())
                ?: LanguageEnum.English,
            displayText = {
                it.toString()
            },
            onOptionClick = {
                language.value = it

                val storeValue = LanguageEnum.getIntValue(language.value as LanguageEnum)
                updateCashRegisterConfig(
                    buildList { add(ApiUtils.Field.clientConfigLanguage to storeValue) }
                )
            }
        )
    }

    Column(
        modifier = Modifier.
            margin(top = if (windowSizeMode!= WindowSizeModeEnum.Desktop)
                Dimen.mediumPadding else  0.px
            )
    ) {
        CustomTextArea(
            modifier = Modifier,
            value = cashRegisterConfig?.companyTitle.orEmpty(),
            label = Strings.current().advertisingText,
            width = Dimen.selectRectPhoneWidth,
            height = Dimen.normalTextAreaHeight,
            maxHeight = Dimen.normalTextAreaHeight,
            onFocusOut = {
                updateCashRegisterConfig(
                    buildList { add(ApiUtils.Field.clientConfigCompanyTitle to it) }
                )
            }
        ) {

        }

        CustomTextArea(
            modifier = Modifier.margin(top = Dimen.normalPadding),
            value = cashRegisterConfig?.companyAddition.orEmpty(),
            label = Strings.current().addition,
            width = Dimen.selectRectPhoneWidth,
            height = Dimen.normalTextAreaHeight,
            maxHeight = Dimen.normalTextAreaHeight,
            onFocusOut = {
                updateCashRegisterConfig(
                    buildList { add(ApiUtils.Field.clientConfigCompanyAddition to it) }
                )
            }
        ) {

        }

        CustomTextArea(
            modifier = Modifier.margin(top = Dimen.normalPadding),
            value = cashRegisterConfig?.companyOptional1.orEmpty(),
            label = Strings.current().optionalOne,
            width = Dimen.selectRectPhoneWidth,
            height = Dimen.normalTextAreaHeight,
            maxHeight = Dimen.normalTextAreaHeight,
            onFocusOut = {
                updateCashRegisterConfig(
                    buildList { add(ApiUtils.Field.clientConfigCompanyOptional1 to it) }
                )
            }
        ) {

        }

        CustomTextArea(
            modifier = Modifier.margin(top = Dimen.normalPadding),
            value = cashRegisterConfig?.companyOptional2.orEmpty(),
            label = Strings.current().optionalTwo,
            width = Dimen.selectRectPhoneWidth,
            height = Dimen.normalTextAreaHeight,
            maxHeight = Dimen.normalTextAreaHeight,
            onFocusOut = {
                updateCashRegisterConfig(
                    buildList { add(ApiUtils.Field.clientConfigCompanyOptional2 to it) }
                )
            }
        ) {

        }
    }
}